 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"4ee745ba01279402158adf103b08b7ce4f12c3b0","3":"85fa9402b4305708a732972f590ed098fadb70e0","6":"component---src-pages-404-jsx","7":"component---src-pages-index-en-jsx","8":"component---src-pages-index-it-jsx","9":"component---src-pages-risultati-ricerca-en-jsx","10":"component---src-pages-risultati-ricerca-it-jsx","11":"component---src-pages-sitemap-en-jsx","12":"component---src-pages-sitemap-it-jsx","13":"component---src-templates-approfondimento-template-en-jsx","14":"component---src-templates-approfondimento-template-it-jsx","15":"component---src-templates-elenchi-elenco-approfondimenti-en-jsx","16":"component---src-templates-elenchi-elenco-approfondimenti-general-en-jsx","17":"component---src-templates-elenchi-elenco-approfondimenti-general-it-jsx","18":"component---src-templates-elenchi-elenco-approfondimenti-it-jsx","19":"component---src-templates-elenchi-elenco-attualita-en-jsx","20":"component---src-templates-elenchi-elenco-attualita-it-jsx","21":"component---src-templates-elenchi-elenco-foto-video-en-jsx","22":"component---src-templates-elenchi-elenco-foto-video-it-jsx","23":"component---src-templates-elenchi-elenco-webinar-en-jsx","24":"component---src-templates-elenchi-elenco-webinar-it-jsx","25":"component---src-templates-elenchi-timeline-en-jsx","26":"component---src-templates-elenchi-timeline-it-jsx","27":"component---src-templates-galleria-flickr-template-en-jsx","28":"component---src-templates-galleria-flickr-template-it-jsx","29":"component---src-templates-galleria-video-template-en-jsx","30":"component---src-templates-galleria-video-template-it-jsx","31":"component---src-templates-mappa-template-en-jsx","32":"component---src-templates-mappa-template-it-jsx","33":"component---src-templates-notizia-template-en-jsx","34":"component---src-templates-notizia-template-it-jsx","35":"component---src-templates-pagina-foglia-completa-template-en-jsx","36":"component---src-templates-pagina-foglia-completa-template-it-jsx","37":"component---src-templates-pubblicazione-template-en-jsx","38":"component---src-templates-pubblicazione-template-it-jsx","39":"component---src-templates-sezione-con-anticipazioni-template-en-jsx","40":"component---src-templates-sezione-con-anticipazioni-template-it-jsx","41":"component---src-templates-videolezioni-template-en-jsx","42":"component---src-templates-videolezioni-template-it-jsx","43":"component---src-templates-webinar-template-en-jsx","44":"component---src-templates-webinar-template-it-jsx"}[chunkId]||chunkId) + "-" + {"0":"cee8addf8ee92a9d9d33","1":"c2fe8482057191dca484","2":"b16a998974caf151afe1","3":"4a868a1f6852271d5048","6":"9bf993f3641403108b4d","7":"52fbc2da94bb20c72259","8":"36cd66ee692f2c1afbf8","9":"eb560d745344157ea8d4","10":"bbbb4c55af2efc409cb6","11":"c388d1e1c0d3c02970e0","12":"4d8af6713ff3b646205a","13":"da2ec85a1a010a00ea08","14":"428bd4d487fc423cac43","15":"104c0a5e12d5f3ea626d","16":"21bf5a684f012f0e11f3","17":"55c492523f9cdc17e2cb","18":"629b98077551b51e9e5f","19":"ecfa25861aaf6cb7bef9","20":"fa4730d7857e838331e0","21":"39c35c2181fba72d6cf8","22":"6df674eed53ae00d3214","23":"d2d93868d7883055390e","24":"ae05efa7387a2d347a27","25":"d7c63089692815b3c2c3","26":"cb12a0d43417b5da7f26","27":"7fc63b2aca9ec3d0f9f5","28":"47c98bed49500debcf45","29":"30a80ff396ac9024abc2","30":"2fe54eff1ffb1745c624","31":"1c1b8a26a5fd949826d6","32":"c4817293037c0bc9b338","33":"3939fa114f599ca1361b","34":"c550a5a8911bd48a4aca","35":"2ee308e67599c9428a16","36":"6101767d4f2c689ce1e6","37":"6954ccc0f36c8bedb19c","38":"2b97ca7cc11151fa8587","39":"a7170ff436d73039aca0","40":"64bc7e730535de57d786","41":"1d15c35f4bc43115f4e5","42":"ead29410ced112e0eeb7","43":"3d922f5aa18d94150695","44":"111275418794785ae5b5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"4ee745ba01279402158adf103b08b7ce4f12c3b0","3":"85fa9402b4305708a732972f590ed098fadb70e0","6":"component---src-pages-404-jsx","7":"component---src-pages-index-en-jsx","8":"component---src-pages-index-it-jsx","9":"component---src-pages-risultati-ricerca-en-jsx","10":"component---src-pages-risultati-ricerca-it-jsx","11":"component---src-pages-sitemap-en-jsx","12":"component---src-pages-sitemap-it-jsx","13":"component---src-templates-approfondimento-template-en-jsx","14":"component---src-templates-approfondimento-template-it-jsx","15":"component---src-templates-elenchi-elenco-approfondimenti-en-jsx","16":"component---src-templates-elenchi-elenco-approfondimenti-general-en-jsx","17":"component---src-templates-elenchi-elenco-approfondimenti-general-it-jsx","18":"component---src-templates-elenchi-elenco-approfondimenti-it-jsx","19":"component---src-templates-elenchi-elenco-attualita-en-jsx","20":"component---src-templates-elenchi-elenco-attualita-it-jsx","21":"component---src-templates-elenchi-elenco-foto-video-en-jsx","22":"component---src-templates-elenchi-elenco-foto-video-it-jsx","23":"component---src-templates-elenchi-elenco-webinar-en-jsx","24":"component---src-templates-elenchi-elenco-webinar-it-jsx","25":"component---src-templates-elenchi-timeline-en-jsx","26":"component---src-templates-elenchi-timeline-it-jsx","27":"component---src-templates-galleria-flickr-template-en-jsx","28":"component---src-templates-galleria-flickr-template-it-jsx","29":"component---src-templates-galleria-video-template-en-jsx","30":"component---src-templates-galleria-video-template-it-jsx","31":"component---src-templates-mappa-template-en-jsx","32":"component---src-templates-mappa-template-it-jsx","33":"component---src-templates-notizia-template-en-jsx","34":"component---src-templates-notizia-template-it-jsx","35":"component---src-templates-pagina-foglia-completa-template-en-jsx","36":"component---src-templates-pagina-foglia-completa-template-it-jsx","37":"component---src-templates-pubblicazione-template-en-jsx","38":"component---src-templates-pubblicazione-template-it-jsx","39":"component---src-templates-sezione-con-anticipazioni-template-en-jsx","40":"component---src-templates-sezione-con-anticipazioni-template-it-jsx","41":"component---src-templates-videolezioni-template-en-jsx","42":"component---src-templates-videolezioni-template-it-jsx","43":"component---src-templates-webinar-template-en-jsx","44":"component---src-templates-webinar-template-it-jsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"b80b0fe4cc74784f818a","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
